import Login from "../containers/Authentication/Login";
import Dashboard from "../containers/UserManagement/Dashboard";
import Account from "../containers/UserManagement/Account";
import CustomBuild from "../containers/UserManagement/CustomBuild";
import BlockingIssue from "../components/UserManagement/BlockingIssue/BlockingIssue.jsx";

const routes = [
  {
    path: "/",
    exact: true,
    component: Login,
    private: false,
  },
  {
    path: "/dashboard",
    exact: false,
    component: Dashboard,
    private: true,
  },
  {
    path: "/account",
    exact: false,
    component: Account,
    private: true,
  },
  {
    path: "/custombuild",
    exact: false,
    component: CustomBuild,
    private: true,
  },
  {
    path: "/blockingissue",
    exact: false,
    component: BlockingIssue,
    private: true,
  },
];

export default routes;
